import {ChangeDetectorRef, Component} from '@angular/core';
import {LoanApplicationService} from '../../loan-application.service';

@Component({
  selector: 'bb-co-maker',
  templateUrl: './co-maker.component.html',
  styleUrls: ['./co-maker.component.scss'],
})
export class CoMakerComponent {
  coMakerRelations = [
    'Spouse',
    'Parent',
    'Sibling',
    'Live-in Partner',
    'Children',
  ];

  constructor(public loan: LoanApplicationService,
              private cdRef: ChangeDetectorRef) {
    this.loan.form.get('has_comaker').patchValue(true);
  }
}
